/* Carnis – «Gjør det til abonnement» i handlekurven (okt. 2026, v1).
   Markup: snippets/carnis-kurv-abo.liquid (skuffen og handlekurvsiden). Lastes fra snippets/cart-drawer.liquid og
   sections/main-cart-footer.liquid (bare én gang).
   - Ett trykk bytter engangslinjene med Storfetalg/Organmix til 3-månedersplanen med /cart/change.js (selling_plan),
     én linje om gangen (linjenøkkel), og tegner kurven på nytt: skuffen via PUB_SUB_EVENTS.cartUpdate (temaets cart.js),
     handlekurvsiden lastes på nytt.
   - Rett etter byttet vises «Abonnement valgt … Angre». «Angre» gjør de samme varene om til engangskjøp igjen
     (selling_plan: null; ble linjen slått sammen med et abonnement som lå der fra før, trekkes bare de byttede
     varene ut og legges inn som engangskjøp). Byttet huskes bare i denne fanen (sessionStorage).
   Ingen avhengigheter utover temaets pubsub.js. */
(function () {
  'use strict';
  if (window.CarnisKurvAbo) return;
  window.CarnisKurvAbo = true;

  var KEY = 'carnis-abo-byttet';
  var R = window.routes || {};
  var URL_CHANGE = (R.cart_change_url || '/cart/change') + '.js';
  var URL_ADD = (R.cart_add_url || '/cart/add') + '.js';
  var URL_CART = (R.cart_url || '/cart') + '.js';
  var NB = ' ';

  function fmt(c) {
    if (window.CarnisKjop && window.CarnisKjop.fmt) return window.CarnisKjop.fmt(c);
    return Math.round(Number(c) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, NB) + NB + 'kr';
  }
  function load() {
    try {
      var r = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
      if (r && r.t && Date.now() - r.t < 3 * 60 * 60 * 1000) return r;
    } catch (e) {}
    return null;
  }
  function save(r) { try { window.sessionStorage.setItem(KEY, JSON.stringify(r)); } catch (e) {} }
  function clear() { try { window.sessionStorage.removeItem(KEY); } catch (e) {} }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'cart');
        return j;
      });
    });
  }
  function getCart() {
    return fetch(URL_CART, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function onCartPage() {
    var p = window.location.pathname.replace(/\/$/, '');
    return p === (R.cart_url || '/cart').replace(/\/$/, '');
  }
  // Tegner kurven på nytt etter endringen
  function refresh(cart) {
    if (onCartPage()) { window.location.reload(); return; }
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'carnis-kurv-abo', cartData: cart });
        return;
      }
    } catch (e) {}
    window.location.reload();
  }
  function busy(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.classList.toggle('is-loading', on);
  }
  function fail(box, btn) {
    busy(btn, false);
    var err = box && box.querySelector('[data-ckv-aboup-err]');
    if (err) { err.textContent = 'Kunne ikke bytte akkurat nå. Prøv igjen.'; err.hidden = false; }
  }

  function convert(btn) {
    var box = btn.closest('[data-ckv-aboup]');
    var lines = [];
    try { lines = JSON.parse(btn.getAttribute('data-lines') || '[]'); } catch (e) { lines = []; }
    if (!lines.length) return;
    busy(btn, true);
    var last = null;
    var chain = Promise.resolve();
    lines.forEach(function (l) {
      chain = chain.then(function () {
        return post(URL_CHANGE, { id: l.key, quantity: l.q, selling_plan: l.plan }).then(function (c) { last = c; });
      });
    });
    chain.then(function () {
      save({ t: Date.now(), save: Number(btn.getAttribute('data-save')) || 0, pct: Number(btn.getAttribute('data-pct')) || 0, lines: lines.map(function (l) { return { v: l.v, q: l.q }; }) });
      refresh(last);
    }).catch(function () {
      // Delvis byttet? Les kurven på nytt, så det som vises stemmer
      getCart().then(function (c) { refresh(c); }).catch(function () { fail(box, btn); });
    });
  }

  function undo(btn) {
    var rec = load();
    if (!rec) return;
    busy(btn, true);
    getCart().then(function (cart) {
      var last = cart;
      var chain = Promise.resolve();
      rec.lines.forEach(function (l) {
        var line = null;
        (cart.items || []).forEach(function (it) { if (!line && it.variant_id === l.v && it.selling_plan_allocation) line = it; });
        if (!line) return;
        if (line.quantity <= l.q) {
          chain = chain.then(function () {
            return post(URL_CHANGE, { id: line.key, quantity: line.quantity, selling_plan: null }).then(function (c) { last = c; });
          });
        } else {
          // Slått sammen med et abonnement som lå der fra før: trekk ut de byttede varene og legg dem inn som engangskjøp
          chain = chain.then(function () {
            return post(URL_CHANGE, { id: line.key, quantity: line.quantity - l.q });
          }).then(function () {
            return post(URL_ADD, { items: [{ id: l.v, quantity: l.q }] });
          }).then(getCart).then(function (c) { last = c; });
        }
      });
      return chain.then(function () { clear(); refresh(last); });
    }).catch(function () {
      getCart().then(function (c) { refresh(c); }).catch(function () { busy(btn, false); });
    });
  }

  // «Abonnement valgt … Angre» rett etter et bytte (når kurven fortsatt har de byttede abonnementsvarene)
  function paint() {
    var rec = load();
    var boxes = document.querySelectorAll('[data-ckv-aboup]');
    if (!rec) return;
    var any = false;
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.querySelector('[data-ckv-aboup-go], [data-ckv-aboup-done]')) { any = true; return; }
      var subv = box.getAttribute('data-sub-variants') || '';
      var has = rec.lines.some(function (l) { return subv.indexOf(',' + l.v + ',') > -1; });
      if (!has) return;
      any = true;
      var p = document.createElement('p');
      p.className = 'ckv-aboup__done';
      p.setAttribute('data-ckv-aboup-done', '');
      p.setAttribute('role', 'status');
      var txt = 'Abonnement valgt' + (rec.pct >= 5 ? ' – ' + rec.pct + '\u00a0% billigere' : '') + '. Hver 3. måned, ingen binding.';
      p.innerHTML = '<span class="ckv-aboup__check" aria-hidden="true"></span><span class="ckv-aboup__donetxt"></span><button type="button" class="ckv-aboup__undo" data-ckv-aboup-undo>Angre</button>';
      p.querySelector('.ckv-aboup__donetxt').textContent = txt;
      box.appendChild(p);
    });
    // Kurven har ikke lenger de byttede varene (fjernet eller endret): glem byttet
    if (boxes.length && !any) clear();
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var go = t.closest('[data-ckv-aboup-go]');
    if (go && !go.disabled) { e.preventDefault(); convert(go); return; }
    var un = t.closest('[data-ckv-aboup-undo]');
    if (un && !un.disabled) { e.preventDefault(); undo(un); }
  });

  function watch() {
    paint();
    if (!('MutationObserver' in window)) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; paint(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
